module.exports = __webpack_public_path__ + "img/info_28.d2ca9438.png";